import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const TaskLoader = ({ message = "Creating your task..." }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(5px)',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '32px 48px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: '0 12px 28px rgba(0, 0, 0, 0.2)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Animated colored border */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: 'linear-gradient(90deg, #4caf50, #2196f3, #9c27b0, #f44336)',
            backgroundSize: '400% 400%',
            animation: 'gradientAnimation 3s ease infinite',
            '@keyframes gradientAnimation': {
              '0%': { backgroundPosition: '0% 50%' },
              '50%': { backgroundPosition: '100% 50%' },
              '100%': { backgroundPosition: '0% 50%' },
            },
          }}
        />
        
        {/* Custom Animated Loader */}
        <Box
          sx={{
            position: 'relative',
            width: '80px',
            height: '80px',
            marginBottom: '20px',
          }}
        >
          {/* Outer rotating circle */}
          <CircularProgress
            size={80}
            thickness={2}
            sx={{
              color: '#2196f3',
              position: 'absolute',
              animation: 'rotateClockwise 2s linear infinite',
              '@keyframes rotateClockwise': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' },
              },
            }}
          />

          {/* Inner counter-rotating circle */}
          <CircularProgress 
            size={60} 
            thickness={4}
            sx={{
              color: '#9c27b0',
              position: 'absolute',
              top: '10px',
              left: '10px',
              animation: 'rotateCounterClockwise 1.5s linear infinite',
              '@keyframes rotateCounterClockwise': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(-360deg)' },
              },
            }}
          />

          {/* Center pulsing circle */}
          <Box
            sx={{
              position: 'absolute',
              width: '40px',
              height: '40px',
              top: '20px',
              left: '20px',
              borderRadius: '50%',
              backgroundColor: '#4caf50',
              animation: 'pulse 1.5s ease-in-out infinite alternate',
              '@keyframes pulse': {
                '0%': { transform: 'scale(0.6)', opacity: 0.6 },
                '100%': { transform: 'scale(1)', opacity: 1 },
              },
            }}
          />
        </Box>

        {/* Message */}
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#333',
            fontWeight: 500,
            textAlign: 'center',
            maxWidth: '300px',
            marginBottom: '10px'
          }}
        >
          {message}
        </Typography>
        
        {/* Removed the additional info message about sample data */}
        
        {/* Animated dots */}
        <Typography 
          sx={{ 
            color: '#666',
            '&::after': {
              content: '"."',
              animation: 'dots 1.5s steps(5, end) infinite',
              '@keyframes dots': {
                '0%, 20%': { content: '"."' },
                '40%': { content: '".."' },
                '60%': { content: '"..."' },
                '80%': { content: '"...."' },
                '100%': { content: '"....."' },
              },
            },
          }}
        >
          Please wait
        </Typography>
      </Box>
    </Box>
  );
};

export default TaskLoader;